import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getOrderReportListUrl, GET_ORDER_REPORT, getFeedbackReportListUrl, getPendingSecurityDepositReportListUrl, GET_PENDING_SECURITY_DEPOSITE_REPORT, GET_FEEDBACK_REPORT, getReceiptReportListUrl, getInvoiceReportListUrl, GET_RECEIPT_REPORT, GET_INVOICE_REPORT, getReportListUrl, GET_REPORT_LIST, headers } from "../../utils/constants"
import moment from 'moment';

export const get_order_report_action = (FromDate, ToDate, centerId, orderStatus, organizerId) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('UserLoginData')).UserID,
            FromDate: FromDate != null && FromDate != '' ? moment(FromDate).format('YYYY-MM-DD') : null,
            ToDate: ToDate != null && ToDate != '' ? moment(ToDate).format('YYYY-MM-DD') : null,
            centerId: centerId,
            orderStatus: orderStatus,
            organizerId: organizerId,
        }
        console.log("input data for search===>", mapdata)
        const res = await axiosGet(getOrderReportListUrl, mapdata, headers);

        dispatch({
            type: GET_ORDER_REPORT,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_feedback_report_action = (FromDate, ToDate, centerId) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('UserLoginData')).UserID,
            FromDate: FromDate != null && FromDate != '' ? moment(FromDate).format('YYYY-MM-DD') : null,
            ToDate: ToDate != null && ToDate != '' ? moment(ToDate).format('YYYY-MM-DD') : null,
            centerId: centerId,
        }
        console.log("input data for search===>", mapdata)
        const res = await axiosGet(getFeedbackReportListUrl, mapdata, headers);

        dispatch({
            type: GET_FEEDBACK_REPORT,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_pending_security_deposit_report_action = () => async (dispatch) => {
    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('UserLoginData')).UserID,
        }
        console.log("input data for search===>", mapdata)
        const res = await axiosGet(getPendingSecurityDepositReportListUrl, mapdata, headers);

        dispatch({
            type: GET_PENDING_SECURITY_DEPOSITE_REPORT,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_receipt_report_action = (FromDate, ToDate) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('UserLoginData')).UserID,
            FromDate: FromDate != null && FromDate != '' ? moment(FromDate).format('YYYY-MM-DD') : null,
            ToDate: ToDate != null && ToDate != '' ? moment(ToDate).format('YYYY-MM-DD') : null,
        }
        console.log("input data for search===>", mapdata)
        const res = await axiosGet(getReceiptReportListUrl, mapdata, headers);

        dispatch({
            type: GET_RECEIPT_REPORT,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_invoice_report_action = (FromDate, ToDate) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('UserLoginData')).UserID,
            FromDate: FromDate != null && FromDate != '' ? moment(FromDate).format('YYYY-MM-DD') : null,
            ToDate: ToDate != null && ToDate != '' ? moment(ToDate).format('YYYY-MM-DD') : null,
        }
        console.log("input data for search===>", mapdata)
        const res = await axiosGet(getInvoiceReportListUrl, mapdata, headers);

        dispatch({
            type: GET_INVOICE_REPORT,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_report_list_action = () => async (dispatch) => {
    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('UserLoginData')).UserID,
        }
        console.log("input data for search===>", mapdata)
        const res = await axiosGet(getReportListUrl, mapdata, headers);

        dispatch({
            type: GET_REPORT_LIST,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};